import React, {useEffect, useState} from 'react';
import {Alert, Button, TextField, Typography} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import {handleInputChange} from "src/components/form/formHandler";
import userApi from "src/api/user/userApi";
import {handleApiError} from "src/api/errorHandler";
import ibanChangeApi from "src/api/payment/ibanChangeApi";
import {apiDateTimeStringToDate} from "src/api/apiDateTimeHandler";
import {addHours} from "date-fns";
import useAuth from "src/hooks/use-auth";

const ChangeIbanPage = () => {
  const initialFormValues = {
    iban: '',
    ibanInTheNameOf: '',
  }
  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [mostRecentIbanChange, setMostRecentIbanChange] = useState(null);
  const { myUser } = useAuth();

  const fetchIbanChanges = async () => {
    const fetchedIbanChanges = await ibanChangeApi.retrieveCollection();
    const ibanChanges = fetchedIbanChanges['hydra:member'];
    setMostRecentIbanChange(ibanChanges ? ibanChanges[0] : null);
  }

  useEffect(() => {
    fetchIbanChanges();
  }, [])

  const getDataFromForm = () => ({
    iban: formValues.iban,
    ibanInTheNameOf: formValues.ibanInTheNameOf
  })

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = getDataFromForm();

    try {
      const result = await userApi.updateIban(myUser.id, data)
      if (result.paymentUrl) {
        window.location.assign(result.paymentUrl);
      }
    } catch (e) {
      handleApiError(e, setFormErrors);
    }
  }

  const ibanChangePending = myUser
    && myUser.ibanVerified
    && mostRecentIbanChange
    && !mostRecentIbanChange.completedAt
    && !mostRecentIbanChange.cancelReason;

  const ibanRecentlyChangeSuccessfully = myUser
    && myUser.ibanVerified
    && mostRecentIbanChange
    && mostRecentIbanChange.completedAt
    // We define recent as less than 1 hour ago
    && addHours(apiDateTimeStringToDate(mostRecentIbanChange.completedAt), 1) >= new Date()

  if (!myUser) {
    return null;
  }

  return (
    <>
      <Typography variant="h2" mb={2}>Rekeningnummer wijzigen</Typography>
      <Typography variant="body1" mb={2}>
        Met onderstaand formulier kan je een nieuw rekening nummer koppelen aan jouw account. Je wordt daarbij doorverwezen naar je bank en dan moet je opnieuw 0,02 cent betalen via je (nieuwe) rekening. Deze krijg je natuurlijk direct weer terug van ons via je persoonlijke saldo.
      </Typography>

      {
        ibanRecentlyChangeSuccessfully
        && <Alert severity="success" sx={{mb: 2}}>Jouw rekeningnummer is successvol aangepast, hieronder staan de actuele gegevens.</Alert>
      }

      <form>
        {formErrors['@general'] && <Alert severity="error" sx={{mb: 2}}>{formErrors['@general']}</Alert> }
        <Grid2 container sx={{ mb: 2 }} spacing={1}>
          <Grid2 xs={12} sm={6}>
            <TextField
              value={myUser.iban}
              name="currentIban"
              label="Huidig rekeningnummer"
              margin="dense"
              fullWidth
              disabled
            />
          </Grid2>
          <Grid2 xs={12} sm={6}>
            <TextField
              value={myUser.ibanInTheNameOf}
              name="currentIbanInTheNameOf"
              label="Huidig ten name van"
              margin="dense"
              fullWidth
              disabled
            />
          </Grid2>
          <Grid2 xs={12} sm={6}>
            <TextField
              value={formValues.iban}
              name="iban"
              label="Nieuw rekeningnummer"
              onChange={(e) => handleInputChange(e, formValues, setFormValues)}
              error={'iban' in formErrors}
              helperText={formErrors.iban}
              margin="dense"
              fullWidth
              required
            />
          </Grid2>
          <Grid2 xs={12} sm={6}>
            <TextField
              value={formValues.ibanInTheNameOf}
              name="ibanInTheNameOf"
              label="Nieuw ten name van"
              onChange={(e) => handleInputChange(e, formValues, setFormValues)}
              error={'ibanInTheNameOf' in formErrors}
              helperText={formErrors.ibanInTheNameOf}
              margin="dense"
              fullWidth
              required
            />
          </Grid2>
        </Grid2>

        {
          ibanChangePending
          && <Alert severity="warning" sx={{mb: 2}}>De betaling van jouw laatste wijziging wordt nog verwerkt of staat nog open, kijk later nog eens.</Alert>
        }

        {
          myUser.ibanVerified && mostRecentIbanChange && mostRecentIbanChange.cancelReason
          && <Alert severity="error" sx={{mb: 2}}>Jouw laatste verificatie is mislukt: {mostRecentIbanChange.cancelReason}</Alert>
        }

        <Button
          onClick={handleSubmit}
          variant="contained"
          color="secondary"
        >
          Verifieer rekeningnummer
        </Button>
      </form>
    </>
  );
}

export default ChangeIbanPage;

ChangeIbanPage.propTypes = {};

ChangeIbanPage.defaultProps = {};
